import { Link, Outlet } from 'react-router'
import { Icon, Text } from '@/design-system'
import { Logo } from '@/app/Logo'
import styles from './PublicLayout.module.css'

/**
 * For pages a visitor must be able to read before they have an account — the
 * terms they are asked to accept on sign-up are the obvious ones.
 */
export function PublicLayout() {
  return (
    <div className={styles.shell}>
      <header className={styles.bar}>
        <Link to="/onboarding" aria-label="Back to the start">
          <Logo size={20} />
        </Link>
        <Link to="/onboarding/create" className={styles.back}>
          <Icon name="arrow_back" size={18} />
          <Text variant="caption" weight="semibold">
            Back to sign-up
          </Text>
        </Link>
      </header>
      <main className={styles.body}>
        <Outlet />
      </main>
    </div>
  )
}
